import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToolbarModule } from 'primeng/toolbar';
import { MenubarModule } from 'primeng/menubar';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { InputTextModule } from 'primeng/inputtext';
import { DataViewModule } from 'primeng/dataview';

import { TagModule } from 'primeng/tag';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { FloatLabelModule } from 'primeng/floatlabel';

import { CheckboxModule } from 'primeng/checkbox';

import { IconFieldModule } from 'primeng/iconfield';
import { TooltipModule } from 'primeng/tooltip';

import { InputIconModule } from 'primeng/inputicon';
import { MenuModule } from 'primeng/menu';
import { CardModule } from 'primeng/card';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { ChipModule } from 'primeng/chip';
import { MultiSelectModule } from 'primeng/multiselect';
import { DividerModule } from 'primeng/divider';
import { FieldsetModule } from 'primeng/fieldset';
import { TimelineModule } from 'primeng/timeline';
export const PRIMENG_MODULES = [ButtonModule,
  ProgressSpinnerModule,
  MenubarModule,
  InputTextModule,
  FloatLabelModule,
  TableModule,
  DataViewModule,
  TagModule,
  CheckboxModule,
  FormsModule,
  CommonModule,
  ReactiveFormsModule,
  ToastModule,
  ConfirmDialogModule,
  DialogModule,
  ToolbarModule,
  IconFieldModule,
  TooltipModule,
  InputIconModule,
  MenuModule,
  CardModule,
  AvatarGroupModule,
  AvatarModule,
  ChipModule,
  MultiSelectModule,
  DividerModule,
  FieldsetModule,
  TimelineModule]

